var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var mapPersonalFormValuesToRequestModel = function (values, customerData) {
    var _a, _b, _c;
    var firstName = values.firstName, lastName = values.lastName, zipCode = values.zipCode;
    var b2cAccount = (_a = customerData.response) === null || _a === void 0 ? void 0 : _a.account;
    if (!b2cAccount) {
        return {
            userProfile: {
                name: __assign(__assign({}, (_c = (_b = customerData === null || customerData === void 0 ? void 0 : customerData.response) === null || _b === void 0 ? void 0 : _b.accountProfile) === null || _c === void 0 ? void 0 : _c.userProfile.name), { firstName: firstName, lastName: lastName }),
            },
        };
    }
    var name = { firstName: firstName, lastName: lastName };
    var profile = b2cAccount.profile;
    var prevZipCode = profile.zipCode, existingZipCode = profile.existingZipCode;
    return {
        account: __assign(__assign({}, b2cAccount), { profile: __assign(__assign({}, b2cAccount === null || b2cAccount === void 0 ? void 0 : b2cAccount.profile), { name: name, zipCode: zipCode, existingZipCode: prevZipCode || existingZipCode, emailId: undefined }) }),
    };
};
export var mapPersonalInfoToOtpRequestModel = function (emailId, encryptVerifiedPhoneToken, verificationMethod) {
    var _a, _b;
    return {
        emailUpdateGetOTPRequest: {
            loginId: emailId,
            newLogonId: emailId,
            sessionId: (_b = (_a = window.THD_ACCOUNT_LIB) === null || _a === void 0 ? void 0 : _a.TMX) === null || _b === void 0 ? void 0 : _b.getTMXsessionId(),
            phoneVerified: encryptVerifiedPhoneToken,
            otpChannel: verificationMethod,
        },
    };
};
export var getB2CUpdateProfileRequestData = function (profileData, newProfileData) {
    if (newProfileData === void 0) { newProfileData = {}; }
    var account = profileData.account;
    return {
        account: __assign(__assign({}, account), { profile: __assign(__assign(__assign({}, account.profile), { emailId: undefined }), newProfileData) }),
    };
};
export var getB2BUpdateProfilePreferenceRequest = function (storeId) {
    return ({
        profilePreference: {
            stores: [
                {
                    storeId: storeId,
                    type: 'PREFERRED',
                },
            ],
            level: 'user',
        },
    });
};
export var mapPersonalInfoToVerifyOtpRequestModel = function (emailOtpResponse, otpValue, profileData) {
    var authId = emailOtpResponse.authId, backendHostName = emailOtpResponse.backendHostName, userId = emailOtpResponse.userId;
    var account = profileData.account;
    return {
        emailUpdateVerifyOTPRequest: {
            authId: authId,
            userId: userId,
            customerId: (account === null || account === void 0 ? void 0 : account.customerAccountId) || '',
            emailLastModifiedDate: (account === null || account === void 0 ? void 0 : account.lastModifiedDate) || '',
            backendHost: backendHostName,
            otp: otpValue,
        },
    };
};
export var mapPersonalInfoToVerifyPhoneOtpRequestModel = function (phoneOtpResponse, encryptVerifiedPhoneToken, emailId, otpValue, profileData, verifiedPhone) {
    var authId = phoneOtpResponse.authId, userId = phoneOtpResponse.userId;
    var account = profileData.account;
    return {
        otpRequest: {
            phoneVerified: encryptVerifiedPhoneToken,
            authId: authId,
            loginId: emailId,
            otp: otpValue,
            phone: {
                number: verifiedPhone.number,
                contactMethodEnumeration: verifiedPhone.contactMethodEnumeration,
                primaryFlag: verifiedPhone.primaryFlag,
                lastModifiedDate: verifiedPhone.lastModifiedDate,
                type: verifiedPhone.type,
            },
            profileLastUpdateTimestamp: (account === null || account === void 0 ? void 0 : account.lastModifiedDate) || 0,
            twoFactorAuthOptIn: 'N',
            userId: userId,
            zipCode: (account === null || account === void 0 ? void 0 : account.profile.zipCode) || '',
        },
    };
};
export var getTextFieldStatus = function (error) {
    return error ? 'error' : undefined;
};
export var generateUserTendersPayload = function (selectedPaymentIds, originalPaymentPermissions) {
    var authorizePayments = selectedPaymentIds.filter(function (id) { return !(originalPaymentPermissions !== null && originalPaymentPermissions !== void 0 ? originalPaymentPermissions : []).includes(id); });
    var deauthorizePayments = (originalPaymentPermissions !== null && originalPaymentPermissions !== void 0 ? originalPaymentPermissions : []).filter(function (id) { return !selectedPaymentIds.includes(id); });
    if (authorizePayments.length > 0 || deauthorizePayments.length > 0) {
        return {
            updateTendersForUserRequest: __assign(__assign({}, (authorizePayments.length > 0 && { authorizePayments: authorizePayments })), (deauthorizePayments.length > 0 && { deauthorizePayments: deauthorizePayments })),
        };
    }
    return null;
};
